"use client";

import { BUSINESS_TIME_SLOTS, TIME_SLOTS } from "@/features/quote/shared/quote-config";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function TimingStep() {
  const { state, toggleTimeSlot, goToStep, step, stepReady, isBusiness } = useWizard();

  return (
    <section>
      {/* Wording is about time of day only - the preceding StartStep already
          asked when the job should be done, and two steps titled "hvornår"
          in a row read as the same question asked twice. */}
      <StepHeading
        title={isBusiness ? "Hvilket tidsrum må firmaet komme i?" : "Hvilket tidsrum på dagen?"}
        body={
          isBusiness
            ? "Vælg et eller flere tidsrum - firmaerne matcher sig til det der passer jer bedst."
            : "Vælg et eller flere tidsintervaller - firmaerne matcher sig til det der passer dig bedst."
        }
        maxW="max-w-[24ch]"
      />
      <CheckRow
        options={isBusiness ? BUSINESS_TIME_SLOTS : TIME_SLOTS}
        values={state.timeSlots}
        onToggle={toggleTimeSlot}
        cols={3}
      />
      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("timing")}
        nextLabel="Næste →"
      />
    </section>
  );
}
